import { useState } from "react";
import { MdClose } from "react-icons/md";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { Label, ScrollableContent } from "./Styles/InputStyles";
import { GoSearch } from "react-icons/go";

const SelectLocationModal = ({
    isOpen,
    onClose,
    title = "Select Option",
    options = [],
    selectedValue,
    onSelect,
    isLoading = false,
    searchPlaceholder = "Search...",
    width
}) => {
    const [searchText, setSearchText] = useState("");

    if (!isOpen) return null;

    const filteredOptions = options.filter((option) =>
        option.name.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleSelect = (id) => {
        onSelect(id);
        onClose();
    };

    const isSelected = (id) => {
        return selectedValue === id;
    };

    return (
        <Overlay>
            <ModalWrapper $width={width}>
                <Header>
                    <h1 className="text-white text-lg font-medium">{title}</h1>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>

                <div className="px-4 pt-4 relative">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder={searchPlaceholder}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                        />
                        {/* Search Icon */}
                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                            <GoSearch className="w-4 h-4 text-gray-400" />
                        </div>
                    </div>
                </div>
                <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                    {isLoading ? (
                        <div className="flex justify-center py-8">
                            <CircularProgress />
                        </div>
                    ) : filteredOptions.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            No options found
                        </div>
                    ) : (
                        filteredOptions.map((option) => (
                            <OptionRow
                                key={option.id}
                                onClick={() => !option.disabled && handleSelect(option.id)}
                            >
                                <Label className={option.disabled ? "text-gray-400" : ""}>
                                    {option.name}
                                </Label>
                                <button
                                    disabled={option.disabled || isLoading}
                                    className={option.disabled ? "cursor-not-allowed" : ""}
                                >
                                    {isLoading ? (
                                        <CircularProgress size={20} />
                                    ) : isSelected(option.id) ? (
                                        <FaRegCheckSquare size={20} className="text-primary-color font-normal text-sm" />
                                    ) : (
                                        <FaRegSquare size={20} className="text-gray-300 font-normal text-sm" />
                                    )}
                                </button>
                            </OptionRow>
                        ))
                    )}
                </ScrollableContent>
            </ModalWrapper>
        </Overlay>
    );
};

const Overlay = tw.div`fixed inset-0 z-50 flex items-center justify-end bg-black/50`
// const ModalWrapper = tw.div`bg-white w-11/12 h-full flex flex-col relative`
const ModalWrapper = tw.div`bg-white h-full flex flex-col relative ${props => props.$width ? `w-${props.$width}` : 'w-11/12'}`;
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`
const OptionRow = tw.div`ml-2 flex items-center justify-between p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50`;

export default SelectLocationModal;